import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // i18next-http-backend: public/locales から翻訳ファイルをロード
  .use(HttpApi)
  // i18next-browser-languagedetector: ユーザーの言語を検出
  .use(LanguageDetector)
  // initReactI18next: i18nインスタンスをreact-i18nextに渡す
  .use(initReactI18next)
  .init({
    // 対応言語のリスト
    supportedLngs: ['en', 'ja', 'zh'],
    // フォールバック言語
    fallbackLng: 'en',
    // デバッグログをコンソールに出力
    debug: process.env.NODE_ENV === 'development',
    // Namespaceの定義
    ns: ['common', 'home', 'analysis', 'taxonomy', 'adminTeam', 'name_detail_tab', 'update_dialog'],
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
